import { render, staticRenderFns } from "./ManageCreditorsToCheck.vue?vue&type=template&id=45a2459e&scoped=true"
import script from "./ManageCreditorsToCheck.vue?vue&type=script&lang=js"
export * from "./ManageCreditorsToCheck.vue?vue&type=script&lang=js"
import style0 from "./ManageCreditorsToCheck.vue?vue&type=style&index=0&id=45a2459e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a2459e",
  null
  
)

export default component.exports